// @flow
import React from "react";
import styles from "./Label.module.css";

const Label = props => {
  const { severity } = props;
  let labelText;
  switch (severity) {
    case 1:
      labelText = "Minimal";
      break;
    case 2:
      labelText = "Low";
      break;
    case 3:
      labelText = "Medium";
      break;
    case 4:
      labelText = "High";
      break;
    case 5:
      labelText = "Critical";
      break;
    default:
      labelText = "";
      break;
  }
  return <span className={styles.label}>{labelText}</span>;
};

export default Label;



// WEBPACK FOOTER //
// ./src/components/shared/SeverityRating/Label/Label.js